var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticStyle: { "border-top": "thin solid rgba(0, 0, 0, 0.12)" } },
    [
      _c(
        "v-toolbar",
        {
          staticStyle: { "margin-top": "8px" },
          attrs: { flat: "", color: "#fff" },
        },
        [
          _c(
            "v-row",
            {
              staticStyle: { "padding-bottom": "3px" },
              attrs: { align: "center" },
            },
            [
              _c("v-spacer"),
              _c(
                "v-col",
                { staticStyle: { "max-width": "150px" }, attrs: { cols: "2" } },
                [
                  _c("v-select", {
                    staticClass: "mt-5",
                    attrs: {
                      dense: "",
                      items: _vm.pageSizes,
                      label: "Items Per Page",
                      value: _vm.pageSize,
                      "menu-props": {
                        top: true,
                        offsetY: true,
                        maxHeight: 500,
                      },
                    },
                    on: {
                      change: function ($event) {
                        return _vm.$emit("update:pageSize", $event)
                      },
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-btn",
                {
                  staticClass: "mx-2",
                  attrs: { icon: "", large: "", disabled: _vm.disablePrevious },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("previous")
                    },
                  },
                },
                [_c("v-icon", [_vm._v("mdi-chevron-left")])],
                1
              ),
              _c("small", [_vm._v("Page " + _vm._s(_vm.page))]),
              _c(
                "v-btn",
                {
                  staticClass: "mx-2",
                  attrs: { icon: "", large: "", disabled: _vm.disableNext },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("next")
                    },
                  },
                },
                [_c("v-icon", [_vm._v("mdi-chevron-right")])],
                1
              ),
              _c(
                "v-col",
                {
                  staticClass: "d-flex align-center py-0",
                  attrs: { cols: "auto" },
                },
                [_vm._t("footer-button")],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }